import { FieldList, FieldName, IRegistrationStepFactory, RegistrationStep, getRemainingSteps } from '../step';
import { StepName } from '../stepNames';
import { mapFieldToStep } from '../fieldsMap';
import { compareSteps } from '../stepPriority';
import { commonFactory } from './commonFactory';

export class EmployerFactory implements IRegistrationStepFactory {
  createStep(name: StepName, fields: FieldList) {
    switch (name) {
      case StepName.Location:
        return this.createLocation(fields);
      case StepName.Acquaintance:
        return this.createAcquaintance(fields);
      default:
        return commonFactory.createStep(name, fields);
    }
  }

  private createLocation(fields: FieldList): RegistrationStep {
    return {
      name: StepName.Location,
      title: 'Город где предстоит работать',
      fields: [
        { name: 'cityId', required: fields.includes('cityId') },
        { name: 'address', required: fields.includes('address') },
        { name: 'location', required: fields.includes('location') },
        { name: 'deviceLocation', required: fields.includes('deviceLocation') },
      ],
    };
  }

  private createAcquaintance(fields: FieldList): RegistrationStep {
    return {
      name: StepName.Acquaintance,
      title: 'Как к Вам обращаться?',
      fields: [
        {
          name: 'name',
          label: 'Имя',
          placeholder: 'Ваше имя',
          required: fields.includes('name'),
        },
        // {
        //   name: 'email',
        //   required: fields.includes('email'),
        //   placeholder: 'Ваш email',
        //   label: 'Email (не обязательно)',
        // },
        {
          name: 'promocode',
          required: fields.includes('promocode'),
        },
      ],
    };
  }

  getStepNames(fields: Readonly<FieldName[]>): StepName[] {
    return getRemainingSteps(fields, mapFieldToStep, compareSteps);
  }
}
